import { IForm, IFormField, ISection, ISelectFormField, FormFieldType } from "../models";
import { IFormSubmission } from "../models/formSubmission";
import { getDateStringInTimezone } from "../utils";

// receive renderer - later can hook renderer to Platform Context for app and site
export async function getFriendlyFormSubmissionDisplay(form: IForm, submission: IFormSubmission, firebase: any) {
	const formDisplay = {
		"Submitted On": getDateStringInTimezone(submission.created_at, true),
	};

	await asyncForEach(form.fields, async (field: IFormField) => {
		formDisplay[field.label] = await getFieldValue(field, submission[field.id], firebase);
	});
	await asyncForEach(form.sections, async (section: ISection, index: number) => {
		const sectionDisplayKey: string = section.name || `Section ${index + 1}`;
		formDisplay[sectionDisplayKey] = {};

		await asyncForEach(section.fields, async (field: IFormField) => {
			formDisplay[sectionDisplayKey][field.label] = await getFieldValue(
				field,
				submission[`${section.id}-${field.id}`],
				firebase
			);
		});
	});

	return formDisplay;
}

async function getFieldValue(field: IFormField, value: any, firebase): Promise<any> {
	if (field.fieldType !== "collection") return value;

	// populate collection data
	const selectField: ISelectFormField = field as ISelectFormField;
	const item = await firebase.firestore().collection(selectField.collectionName).doc(value).get();
	const data = item && item.data ? item.data() : {};
	delete data.active;
	console.log("collection item data:  data:", data);
	return data;
}

async function asyncForEach(array, callback) {
	for (let index = 0; index < array.length; index++) {
		await callback(array[index], index, array);
	}
}

export const convertDateToUTC = (date: Date): Date => {
	const _utc = Date.UTC(
		date.getUTCFullYear(),
		date.getUTCMonth(),
		date.getUTCDate(),
		date.getUTCHours(),
		date.getUTCMinutes(),
		date.getUTCSeconds()
	);
	return new Date(_utc);
};

export const getKeyboardType = (fieldType: FormFieldType) => {
	switch (fieldType) {
		case "email":
			return "email-address";
		case "date":
		case "datetime":
			return "numeric"; // TODO: check
		case "number":
			return "numeric";
		case "phone":
			return "phone-pad";
		default:
			return "default";
	}
};
